import { render, staticRenderFns } from "./FormDependentTipoRegistro.vue?vue&type=template&id=3fea6941"
import script from "./FormDependentTipoRegistro.vue?vue&type=script&lang=js"
export * from "./FormDependentTipoRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports